<template>
  <form-template
    :data="data"
    :blocks="blocks"
    :snackbar="snackbar"
    title="Изображение с текстом"
    @save="save"
  >
    <v-file-input accept="image/*" label="Изображение" @change="imageUpload" />
    <img
      v-if="override.content.image"
      width="100%"
      :src="override.content.image"
      alt=""
    />
    <html-field v-model="override.content.text"></html-field>
  </form-template>
</template>

<script>
import formMixin from "./formMixin";
import FormTemplate from "./Template";
import HtmlField from "../../InputBlock/HtmlField";
import readBase64 from "../../../mixins/readBase64";

export default {
  name: "FormImageText",
  components: { FormTemplate, HtmlField },
  mixins: [formMixin, readBase64],
  data() {
    return {
      override: {
        content: Object.assign({ image: null, text: null }, this.data.content)
      }
    };
  },
  methods: {
    imageUpload(file) {
      this.readBase64(file).then((image) => {
        this.override.content.image = image;
      });
    }
  }
};
</script>
